/*
 * Add rows to the order
 */

import $ from 'jquery';
import Mustache from 'mustache';

class Row {

  constructor ( element ) {
    this._element = element;
  }

  create ( relatedTarget ) {
    this._request( 'create', relatedTarget );
  }

  update ( relatedTarget ) {
    this._request( 'update', relatedTarget );
  }

  delete ( relatedTarget ) {
    this._request( 'delete', relatedTarget );
  }

  _request ( method, relatedTarget ) {
    let url = this._element.data( 'action' );
    let params = this._element.serialize();

    if ( ! url || ! url ) {
      return;
    }
    params = params.replace( /&/g, '/' );

    url += '/' + method;
    url += '/' + params;

    const EVENTS = {
      start: 'start.' + method + '.row',
      success: 'success.' + method + '.row',
      error: 'error.' + method + '.row',
      finish: 'finish.' + method + '.row'
    }

    this._element.trigger( EVENTS.start );

    $.ajax( url )
      .done( ( data ) => {
        if ( ! data.errors.length ) {
          this._element.trigger( $.Event( EVENTS.success, { 'relatedTarget': relatedTarget } ) );
        } else {
          this._element.trigger( $.Event( EVENTS.error, { 'relatedTarget': relatedTarget } ) );
        }
      } )
      .fail( () => {
        this._element.trigger( $.Event( EVENTS.error, { 'relatedTarget': relatedTarget } ) )
      } )
      .always( () => {
        this._element.trigger( $.Event( EVENTS.finish, { 'relatedTarget': relatedTarget } ) )
      } );
  }

  static _handleEvent () {
    return function ( e ) {
      const isForm = e.currentTarget.nodeName === 'FORM';
      if ( isForm && e.type !== 'submit') {
        if (e.type !== 'onchage' &&  !e.currentTarget.classList.contains('onChangeForm')){
          return;
        }
      }
      e.preventDefault();
      let element = $( e.currentTarget );
      const method = element.data( 'method' );
      if ( ! isForm ) {
        element = element.closest( 'form' );
      }
      Row._jQueryInterface.call( element, method, e.currentTarget );

    }
  }

  static _jQueryInterface ( method, relatedTarget ) {
    return this.each( function () {
      let element = $( this );
      let data = element.data( '_row' );

      if ( ! data ) {
        data = new Row( element );
        $( this ).data( '_row', data )
      }

      if ( typeof method === 'string' ) {
        if ( typeof data[method] === 'undefined' ) {
          throw new TypeError( `No method named "${method}"` );
        }
        data[ method ]( relatedTarget );
      }
    } );
  }
}

/**
 * ------------------------------------------------------------------------
 * Data Api implementation
 * ------------------------------------------------------------------------
 */
const methods = [ 'create', 'update', 'delete' ];
const events = [ 'submit change', 'submit change', 'click change' ];
for ( let i = 0, len = methods.length, method = null; i < len; i++ ) {
  method = methods[i];
  $(document).on( events[i], `[data-method="${method}"]`, Row._handleEvent() );
}


/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 */

$.fn.orderRow             = Row._jQueryInterface
$.fn.orderRow.Constructor = Row

export default Row;